var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceCalibration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.654,
    height: 39.375,
    viewBox: "0 0 46.654 39.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6148",
    "data-name": "Group 6148",
    transform: "translate(9.026 6.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M3125.121,312.829a3.438,3.438,0,1,1,3.438-3.438A3.442,3.442,0,0,1,3125.121,312.829Zm0-5.839a2.4,2.4,0,1,0,2.4,2.4A2.4,2.4,0,0,0,3125.121,306.99Z",
    transform: "translate(-3110.72 -305.954)",
    fill: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M3129.8,314.324a1.056,1.056,0,0,1,.994.783c1.478,5.57,2.95,11.141,4.371,16.726a1.116,1.116,0,0,1-1.079,1.392c-6.637.01-21.975.006-26.505,0a.984.984,0,0,1-.948-1.245l4.528-16.879a.984.984,0,0,1,.947-.732C3115.38,314.356,3128.311,314.293,3129.8,314.324Z",
    transform: "translate(-3106.596 -308.24)",
    fill: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_77_270",
    "data-name": "Component 77 \\u2013 270",
    transform: "translate(-8.526 -6.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 45.654,
    height: 38.375,
    rx: 4,
    fill: "none",
    stroke: "#b6b6b6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceCalibration);
export default __webpack_public_path__ + "static/media/deviceCalibration.4bd8f00eb35e5f53df8b92f4f1cc0092.svg";
export { ForwardRef as ReactComponent };